import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const RevokeApplicationsSingle = MatxLoadable({
    loader: () =>
        import ("./RevokeApplicationsSingle")
})
const AllRevokeApplicationsSingle = MatxLoadable({
    loader: () =>
        import ("./AllRevokeApplicationsSingle")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const RevokeApplicationsSingleRoutes = [
    {
        path: "/revoke_application_single",
        component: AllRevokeApplicationsSingle,
        // settings
    },

];

export default RevokeApplicationsSingleRoutes;